import React from 'react';
import './libro_bitcoin.css';
import libro_azul from '../../../../assets/img/Bitcoin-imgbook2.png'

import LA_vector from '../../../../assets/imgs/home_cinco/LA_vector.png'
import { useTranslation } from 'react-i18next'

export const Libro_bitcoin = () => {

    const [t, i18n] = useTranslation("home");
    const liga_lang1 = '/' + i18n.language + "/librobitcoin";

    return (
        <div class='LA_contenedor'>
            <div class="LA_contenedor_escritorio">
                <div class="LA_contenedor_img">
                    <img src={libro_azul} alt="Imagen libro" class="LA_libro_img LA_libro_img_bitcoin" />
                </div>
                <div class="LA_contenedor_txt">
                    <div dangerouslySetInnerHTML={{ __html: t('slider.Bitcoin-top') }}></div>
                    <img src={LA_vector} alt="Imagen Vector" class="LA_linea" />
                    <p class='p-bitcoin-book-name' dangerouslySetInnerHTML={{ __html: t('slider.bitcoin3') }}></p>
                    <a class="LA_button" href={liga_lang1}>{(t('slider.more'))}</a>
                </div>
            </div>
            <div class='LA_contenedor_movil'>
                <div class="LA_movil_titulo">
                    <h2>{(t('slider.bitcoin1'))} <br />
                        <span>{(t('slider.bitcoin2'))}</span></h2>
                </div>
                <div class="LA_movil_txt LA_BIT_movil_txt">
                    <p class='p-bitcoin-book-name-mov' dangerouslySetInnerHTML={{ __html: t('slider.bitcoin4') }}></p>
                </div>
                <div class="LA_movil_img">
                    <img src={libro_azul} alt='Imagen de libro azul' />
                    <a
                        class="LA_movil_img-button"
                        href={liga_lang1}
                    >
                        {(t('slider.more'))}
                    </a>
                </div>
            </div>
        </div>
    )
}
